import { render, staticRenderFns } from "./groupStatistic.vue?vue&type=template&id=da2409dc"
import script from "./groupStatistic.vue?vue&type=script&lang=js"
export * from "./groupStatistic.vue?vue&type=script&lang=js"
import style0 from "./groupStatistic.vue?vue&type=style&index=0&id=da2409dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports